import { router, usePage } from '@inertiajs/react'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { SharedProps } from '@/types'
import { CalendarIcon } from 'lucide-react'

export function FinancialYearSelect() {
  const { financial_years, current_financial_year } = usePage<SharedProps>().props

  return (
    <Select
      value={current_financial_year.param}
      onValueChange={(value) => {
        const params = new URLSearchParams(window.location.search)
        params.set('financial_year', value)
        params.delete('page')

        router.get(window.location.pathname, Object.fromEntries(params), { preserveState: true })
      }}
    >
      <SelectTrigger size="sm" className="w-[160px] text-[13px]" aria-label="Financial year">
        <div className="flex items-center gap-2">
          <CalendarIcon />
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {financial_years.map((fy) => (
            <SelectItem key={fy.param} value={fy.param}>
              {fy.name}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
